import React from 'react';
import { TryTeetshHeader } from 'components/TryTeetshHeader';
import { useParams } from 'react-router-dom';
import ManualClassroomsProvider from 'containers/App/context/ClassroomsContext/ManualClassroomsContext';
import { FakeSchoolSchoolyearProvider } from 'containers/App/context/FakeSchoolSchoolyearProvider';
import FakeUserProvider from 'containers/App/context/FakeUserProvider';
import { NotFoundPage } from 'components/ErrorPage/NotFoundPage';
import { useTranslation } from 'react-i18next';
import Logo from 'assets/logo-white.png';
import { useGetShareEDT } from './useGetShareEDT';
import useEDT from 'queries/edt/useEDT';
import Spinner from 'components/Spinner/ScreenSpinner';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import EDT from '../EDT';
import ManualCustomFieldDefinitionsProvider from 'containers/App/context/EventCustomFieldDefinitionsContext/ManualCustomFieldDefinitionsProvider';

function EDTShare({
  weektableId,
  onDuplicateShareEDT,
}: {
  weektableId: string;
  onDuplicateShareEDT: () => void;
}) {
  const { data, isLoading } = useEDT({
    edtId: weektableId,
    enabled: true,
  });
  const { guestMode } = useUser();

  if (isLoading) return <Spinner />;
  if (!data || !guestMode) return null;

  return (
    <EDT
      emploiDuTemps={data}
      isGuest={guestMode.enabled}
      isReadOnly={guestMode.permission === 'read'}
      onDuplicateShareEDT={onDuplicateShareEDT}
      enableEventTemplate={false}
    />
  );
}

export function EDTShareWrapper() {
  const params = useParams<{
    token: string;
    userId: string;
  }>();
  const userId = params.userId as string;
  const token = params.token as string;
  const { t } = useTranslation(['emploiDuTemps']);
  const { data, error } = useGetShareEDT(userId, token);

  if (error?.response?.status === 404) {
    return (
      <NotFoundPage title={t('emploiDuTemps:messages.share.notFoundError')} />
    );
  }
  if (!data) return null;

  return (
    <div>
      <div className="dark">
        <TryTeetshHeader
          utmCampaign="share_emploi_du_temps"
          title={<img style={{ height: '30px' }} alt="Teetsh" src={Logo} />}
        />
      </div>
      <FakeUserProvider
        user={{
          id: userId,
          location: data.tz,
          locale: data.locale,
          country: data.country,
          boLabels: data.boLabels,
          referencielId: data.referentielId,
          guestMode: {
            enabled: true,
            permission: data.permission,
          },
        }}
      >
        <FakeSchoolSchoolyearProvider
          schoolyear={data.schoolyear}
          school={data.school}
        >
          <ManualClassroomsProvider classrooms={data.classrooms}>
            <ManualCustomFieldDefinitionsProvider definitions={[]}>
              <EDTShare
                weektableId={data.weektableId}
                onDuplicateShareEDT={() => {
                  window.open(
                    `/inscription?share-token=${token}&share-entity-id=${data.weektableId}&share-entity-type=emploiDuTemps`,
                    '_self',
                  );
                }}
              />
            </ManualCustomFieldDefinitionsProvider>
          </ManualClassroomsProvider>
        </FakeSchoolSchoolyearProvider>
      </FakeUserProvider>
    </div>
  );
}
